import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MaterialLibraryModule } from '@cdw-ae/common-frontend-materials';
import { CdwIconModule } from '@cdw-ae/common-ui-components-icon';

import { CdwButtonComponent } from './cdw-button/cdw-button.component';

@NgModule({
  imports: [CommonModule, MaterialLibraryModule, CdwIconModule],
  declarations: [CdwButtonComponent],
  exports: [CdwButtonComponent],
})
export class CdwButtonModule {}